import { FormControl, OutlinedInput, InputAdornment, Grid, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useState, useEffect, useCallback } from "react";

const MonthlyIncome = ({ page, setPage, formData, setFormData }) => {
    const [incomeError, setIncomeError] = useState(null);
    const [depositError, setDepositError] = useState(null);

    const onMonthlyIncomeChange = (e) => {
        if (e.target.value.length > 5) {
            e.preventDefault();
        } else if (isNaN(e.target.value)) {
            e.preventDefault();
        } else {
            setFormData({ ...formData, monthlyIncome: parseInt(e.target.value, 10) });
        }
        setIncomeError(null);
    }

    const validateData = () => {
        var valid = true;
        if (formData.monthlyIncome === "") {
            setIncomeError(formData.lang === "fr" ? "Veuillez saisir votre revenu mensuel" : "Please enter your monthly income");
            valid = false;
        } else {
            setIncomeError(null);
        }

        if (formData.directDeposit === "") {
            setDepositError(formData.lang === "fr" ? "Ceci est nécessaire" : "This option is required");
            valid = false;
        } else {
            setDepositError(null);
        }

        if (valid === true) {
            window.dataLayer.push({'event': 'loan_step6', 'loanEvent': 'step6', 'loanEventID': 7});
            // quebec only
            // window.dataLayer.push({'event': 'loan_step6q', 'loanEvent': 'step6q', 'loanEventID': '7q'});
            setPage(page + 1);
        }
    }

    const preventPaste = (e) => {
        e.preventDefault();
    };

    const updateFormData = useCallback(() => {
        setFormData(formData);
    }, [formData, setFormData]);

    useEffect(() => {
        updateFormData();
    }, [updateFormData]);

    useEffect(() => {
        setIncomeError(null);
        setDepositError(null);
    }, [formData.lang]);

    return (
        <div className="card">
            <div className="card-div">
                <div className="textfield-label">{formData.lang === "fr" ? "Combien gagnez-vous par mois?" : "How much do you make in a month?"}</div>
                <FormControl fullWidth>
                    <OutlinedInput
                        type="number"
                        startAdornment={
                            <div className="custom-start-adornment-div">
                                <InputAdornment style={{ marginLeft: 10 }} position="start">$</InputAdornment>
                            </div>
                        }
                        endAdornment={
                            <div className="custom-end-adornment-div">
                                <InputAdornment style={{ marginRight: 10 }} position="end">.00</InputAdornment>
                            </div>
                        }
                        value={formData.monthlyIncome}
                        onPaste={preventPaste}
                        onWheel={(e) => e.target.blur()}
                        onKeyDown={(e) => (e.key === "e" || e.key === "." || e.code === 'Minus' || e.code === 'ArrowUp' || e.code === 'ArrowDown') && e.preventDefault()}
                        onChange={onMonthlyIncomeChange}
                    />
                </FormControl>
                <div className="error-text">{incomeError}</div>
                <div className="textfield-label">{formData.lang === "fr" ? "Recevez-vous cela par dépôt direct?" : "Do you receive this by direct deposit?"}</div>

                {/* <FormControl component="fieldset">
                    <RadioGroup aria-label="direct-deposit" value={formData.directDeposit} onChange={(e) => setFormData({ ...formData, directDeposit: e.target.value })}>
                        <div className="textfield-group-2">
                            <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                            <FormControlLabel value="no" control={<Radio />} label="No" />
                        </div>
                    </RadioGroup>
                </FormControl> */}

                <ToggleButtonGroup
                    value={formData.directDeposit}
                    exclusive
                    onChange={(e) => setFormData({ ...formData, directDeposit: e.target.value })}>
                    <ToggleButton value="yes">
                        {formData.lang === "fr" ? "Oui" : "Yes"}
                    </ToggleButton>
                    <ToggleButton value="no">
                        {formData.lang === "fr" ? "Non" : "No"}
                    </ToggleButton>
                </ToggleButtonGroup>
                <div className="error-text">{depositError}</div>

                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <button className="nav-button"
                            onClick={() => {
                                setPage(page - 1);
                            }}>
                            {formData.lang === "fr" ? "Précédent" : "Previous"}
                        </button>
                    </Grid>
                    <Grid item xs={6}>
                        <button className="nav-button"
                            onClick={() => {
                                validateData();
                            }}>
                            {formData.lang === "fr" ? "Suivant" : "Next"}
                        </button>
                    </Grid>
                </Grid>
            </div>
        </div>
    );
};

export default MonthlyIncome;